import { ReactNode } from "react";
import RequireRole from "@/components/auth/RequireRole";
import { AdminMFAGate } from "@/components/admin/AdminMFAGate";
import PlatformErrorBoundary from "@/components/PlatformErrorBoundary";

/**
 * Admin route guard that enforces BOTH role-gating AND MFA on every /admin/* surface.
 * Use this instead of bare <RequireRole roles={["admin"]}> for any admin route — direct
 * URL probes must never reach an admin page without a fresh TOTP verification.
 *
 * Wraps children in a PlatformErrorBoundary so a runtime error in one admin page
 * doesn't black-hole the whole admin shell.
 */
export default function AdminGuard({
  children,
  label = "Admin",
  backPath = "/admin",
}: {
  children: ReactNode;
  label?: string;
  backPath?: string;
}) {
  return (
    <RequireRole roles={["admin"]}>
      <AdminMFAGate>
        <PlatformErrorBoundary platformName={label} backPath={backPath}>
          {children}
        </PlatformErrorBoundary>
      </AdminMFAGate>
    </RequireRole>
  );
}
